import { FeatureFlagEnum } from 'src/app/shared/enums/feature-flag.enum';

/**
 * Used to override a feature flag when running "npm run start:local" or using the local environment file.
 *
 * If the feature flag is not provided, it will use the environment specific feature flag from release
 * or production.
 *
 * NOTE: Please use FeatureFlagEnum as keys to make it easier to clean on feature flag removal.
 *
 * DO NOT COMMIT CHANGES TO THIS FILE.
 */
export const FeatureFlagLocalOverride = {
  [FeatureFlagEnum.FAKE_LOCAL_OVERRIDE_FLAG]: true,
};
